import React, { Component } from 'react';
import Gravatar from 'react-gravatar';
import { Spinner } from 'reactstrap';
import Modal from 'react-bootstrap4-modal';
import Notifications8, {notify} from 'react-notify-toast';
import BookingQuickview2 from './BookingQuickview.2';
import BookingServices from './BookingServices';
import BookingScheduler from './BookingScheduler';
import BookingInvoice from './BookingInvoice';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { inject, observer } from 'mobx-react';
import { connectionGet, connectionPost } from '../../utils/connection';
import moment from 'moment';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';


@inject('userStore')
class Bookings2 extends Component {
  constructor(props){
    super(props);
    this.state = {
      item_list_orig:[],
      item_list:[],
      loading:true,
      quickviewVisible:false,
      quickviewBookingHashId:null,
      servicesBooking:null,
      servicesComponent:null,
      bus_service_list:[],
      filter:'active',
      modalTitle:''
    }
  }

  componentDidMount(){
    this.fetchBookings('active');
    this.fetchBusinessServices();
  }

  fetchBookings = (filter) => {
    this.setState({loading:true, filter:filter},()=>{
      connectionGet('v2/bookings', {business_hash_id: this.props.userStore.business_primary.hash_id, filter:filter}, {username: this.props.userStore.token})
      .then((res) => {
        this.setState({
          item_list:res.data.item_list,
          item_list_orig:res.data.item_list,
          loading:false
        });
      }).catch((error) => {
        console.log(error);
        return error;
      });
    });
  }

  fetchBusinessServices = () => {
    connectionGet('v2/business-services', {business_hash_id: this.props.userStore.business_primary.hash_id}, {username: this.props.userStore.token})
    .then((res) => {
      this.setState({
        bus_service_list:res.data.service_list
      });
    }).catch((error) => {
      console.log(error);
      return error;
    });
  }

  selectFilter = (filter) => {
    this.fetchBookings(filter);
  }

  openQuickview = (hash_id) => {
    this.setState({
      quickviewBookingHashId:hash_id,
      quickviewVisible:true
    })
  }

  modalBackgroundClicked = () => {
    this.setState({
      visible:!this.state.visible,
      component:null,
      booking:null
    });
  }

  modalHandler = (booking, component, title) => {
    this.setState({
      booking:booking,
      component:component,
      visible:!this.state.visible,
      modalTitle:title
    })
  }

  closeQuickview = () => {
    this.setState({
      quickviewVisible:false,
      quickviewBookingHashId:null
    })
  }

  back = () => {
    this.setState({
      servicesBooking:null,
      servicesComponent:null,
      component:null
    })
  }

  servicesHandler = (booking) => {
    this.setState({
      servicesBooking:booking,
      servicesComponent:<BookingServices backHandler={this.back} booking={booking} deleteServiceHandler={this.deleteService} addServiceHandler={this.addService} bus_service_list={this.state.bus_service_list}/>
    })
  }

  deleteService = (service) => {
    let temp_service = Object.assign({}, this.state.servicesBooking);
    let s_index = temp_service.service_list.findIndex(x => x.id === service.id);
    temp_service.service_list.splice(s_index, 1);
    let temp_item_list = Object.assign([], this.state.item_list);
    let index = this.state.item_list.findIndex(x => x.id === this.state.servicesBooking.id);
    temp_item_list[index] = temp_service
    this.setState({
      item_list:temp_item_list,
      item_list_orig:temp_item_list
    })
  }

  addService = (service) => {
    let temp_service = Object.assign({}, this.state.servicesBooking);
    let s_index = temp_service.service_list.findIndex(x => x.id === service.id);
    temp_service.service_list.push(service);
    let temp_item_list = Object.assign([], this.state.item_list);
    let index = this.state.item_list.findIndex(x => x.id === this.state.servicesBooking.id);
    temp_item_list[index] = temp_service
    this.setState({
      item_list:temp_item_list,
      item_list_orig:temp_item_list
    })
  }

  scheduleHandler = (booking) => {
    this.setState({
      servicesBooking:booking,
      servicesComponent:<BookingScheduler backHandler={this.back} booking={booking} height={this.state.height}/>
    })
  }

  reset = () => {
    this.setState({
      item_list:this.state.item_list_orig
    })
  }

  invoiceHandler = (invoice, booking) => {
    this.setState({
      servicesBooking:booking,
      visible:!this.state.visible,
      servicesComponent:<BookingInvoice backHandler={this.back} booking={booking} invoice={invoice}/>
    })
  }

  createInvoiceHandler = (booking, sys_invoice_type_id) => {
    // create invoice and call invoiceHandler
    connectionPost('create/invoice', {bk_hash_id: booking.hash_id, sys_invoice_type_id:sys_invoice_type_id}, {username: this.props.userStore.token}
    ).then((res) => {
      if (res.data.invoice){
        this.invoiceHandler(res.data.invoice, booking);
      }
    }).catch((error) => {
      console.log(error);
      return error;
    });
  }

  startTimeEdit = (readyTime, booking) => {
    if (booking){
      connectionPost('save/ready_time', {bk_hash_id: booking.hash_id, ready_time:readyTime}, {username: this.props.userStore.token}
      ).then((res) => {
        if (res.data.errors === 0){
          let temp_booking = Object.assign({}, booking);
          let temp_item_list = Object.assign([], this.state.item_list);
          let index = this.state.item_list.findIndex(x => x.id === booking.id);
          temp_item_list[index] = res.data.booking
          this.setState({
            item_list:temp_item_list,
            item_list_oring:temp_item_list,
            quickviewBooking:res.data.booking
          })
          alert('Event date/time updated.  If you have published a schedule, make necessary changes and be sure to republish a new one!');
        }
      }).catch((error) => {
          console.log(error);
          return error;
      });
    } else {
      alert('Undefined Booking');
    }
  }

  editBooking = (booking) => {
    connectionPost('save/booking', {booking: booking}, {username: this.props.userStore.token}
    ).then((res) => {
      if (res.data.errors === 0){
        let temp_booking = Object.assign({}, res.data.booking);
        let temp_item_list = Object.assign([], this.state.item_list);
        let index = this.state.item_list.findIndex(x => x.id === res.data.booking);
        temp_item_list[index] = res.data.booking
        this.setState({
          item_list:temp_item_list,
          quickviewBooking:res.data.booking
        })
      }
      alert(res.data.message);
    }).catch((error) => {
        console.log(error);
        return error;
    });
  }

  resetPassword = (booking) => {
    if (booking){
      connectionPost('post/pw_reset', {hash_id:booking.user_hash_id}, {username: this.props.userStore.token}
      ).then((res) => {
        if (res.data.errors === 0){
          alert(res.data.message);
        } else {
          alert(res.data.message);
        }
      }).catch((error) => {
        return error;
      });
    }
  }

  resendEmail = (booking) => {
    if (booking){
      connectionPost('post/resend-email', {hash_id:booking.user_hash_id}, {username: this.props.userStore.token}
      ).then((res) => {
        if (res.data.errors === 0){
          alert(res.data.message);
        } else {
          alert(res.data.message);
        }
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }
  }

  inactivateHandler = () => {
    this.setActiveTab('inactive');
    this.modalBackgroundClicked();
  }

  render(){
    const {item_list, loading, filter} = this.state;
    const { SearchBar } = Search;
    const selectRow = {
      hideSelectColumn:true,
      clickToSelect:true,
      mode: 'radio',
      bgColor: '#ecf5fe',
      onSelect: (row, isSelect, rowIndex, e) => {
        this.openQuickview(row.hash_id);
      }
    };
    const expandRow = {
      renderer: row => (
        <div>
          <p>{ `This Expand row is belong to rowKey ${row.id}` }</p>
          <p>You can render anything here, also you can add additional data on every row object</p>
          <p>expandRow.renderer callback will pass the origin row object to you</p>
        </div>
      )
    };
    const columns = [{
      dataField: 'id',
      text: 'ID',
      hidden:true
    }, {
      dataField: 'date',
      text: 'Event Details',
      sort:true,
      headerStyle: (column, colIndex) => {
        return { width: '20%' };
      },
      formatter: (cellContent, row) => {
        var dt_class = 'badge badge-success';
        if (row.days_until < 7){
            dt_class = 'badge badge-danger';
        }
        return (
          <div className="d-flex justify-content-between">
            <div>
              <h5 className="mb-0">{row.date}</h5>
              <span className="d-block"><strong>Ready By:</strong> {row.ready_time}</span>
              <span className="fw-300">Service Total: <strong>${row.service_total}</strong></span>
            </div>
            <div>
              <strong>Days Until</strong><br/>
              <span className={dt_class}>{row.days_until}</span>
            </div>
          </div>);
      }
    }, {
      dataField: 'last_name',
      text: 'Contact Info',
      isDummyField:true,
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '20%' };
      },
      // events: {
      //   onClick: (e, column, columnIndex, row, rowIndex) => {
      //     e.stopPropagation();
      //   },
      // },
      formatter: (cellContent, row) => {
        return (
          <div className="text-truncate">
            <h5 className="mb-0">{row.full_name}</h5>
            {row.phone ? (
            <a href={"tel:" + row.phone} className="d-block fs-12 text-info"><i className="text-dark fa fa-phone-square"></i> {row.phone}</a>
            ) : null}
            <a href={"mailto:" + row.email} className="d-block fs-12 text-info"><i className="text-dark ti-email"></i> {row.email ? row.email : row.email}</a>
          </div>
        );
      }
    },{
      dataField:'first_name',
      text: 'First Name',
      hidden:true,
    },{
      dataField:'last_name',
      text: 'Last Name',
      hidden:true,
    },{
      dataField:'email',
      text: 'Email',
      hidden:true,
    },{
      dataField:'location_name',
      text: 'Location',
      hidden:true,
    },{
      dataField:'address1',
      text: 'Address',
      hidden:true,
    },{
      dataField:'address2',
      text: 'Address2',
      hidden:true,
    },{
      dataField:'phone',
      text: 'phone',
      hidden:true,
    }, {
      dataField: 'distance',
      text: 'Location',
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '20%' };
      },
      formatter: (cellContent, row) => {
        var dt_class = 'badge badge-success';
        if (row.distance && row.distance > 20){
            dt_class = 'badge badge-danger';
        }
        return (
          <div className="d-flex justify-content-between">
            <address className="mb-0">
              <strong>{row.location_name}</strong><br/>
              <span>{row.address1}</span><br/>
              <span>{row.city} {row.state} {row.postal}</span><br/>
            </address>
            <div>
              <strong>Distance</strong><br/>
              <span className={dt_class}>{row.distance}mi</span>
            </div>
          </div>);
      }
    }, {
      dataField: 'assigned_artists',
      text: 'Art Assign',
      sort:true,
      headerStyle: (column, colIndex) => {
        return { width: '10%' };
      },
      formatter: (cellContent, row) => {
        return (
            <div>
              {row.assigned_artists ? <span className="badge badge-success d-block">YES</span> : <span className="badge badge-danger d-block">NO</span>}
            </div>
        );
      }
    }, {
      dataField: 'trial_scheduled',
      text: 'Trial Sch',
      sort:true,
      headerStyle: (column, colIndex) => {
        return { width: '10%' };
      },
      formatter: (cellContent, row) => {
        return (
            <div>
              {row.trial_scheduled ? <span className="badge badge-success d-block">YES</span> : <span className="badge badge-danger d-block">NO</span>}
            </div>
        );
      }
    }, {
      dataField: 'schedule_published',
      text: 'Sch Pub',
      sort:true,
      headerStyle: (column, colIndex) => {
        return { width: '10%' };
      },
      formatter: (cellContent, row) => {
        return (
            <div>{row.schedule_published ? <span className="badge badge-success d-block">YES</span> : <span className="badge badge-danger d-block">NO</span>}</div>
        );
      }
    }, {
      dataField: 'follow_up',
      text: 'Follow Up',
      sort:true,
      align:'center',
      headerStyle: (column, colIndex) => {
        return { width: '10%' };
      },
      formatter: (cellContent, row) => {
        return (
            <div>
              {row.follow_up === 1 ? <i className="fa fa-flag text-danger fs-18"/> : null}
            </div>
        );
      }
    }];
    const options = {
      sizePerPage: 50,
    };
    return (
      <React.Fragment>
        <Modal visible={this.state.visible} onClickBackdrop={this.modalBackgroundClicked} dialogClassName="modal-lg w-900px">
            <Notifications8  options={{wrapperId:'modal-notifications'}} />
            <div className="modal-header">
                <h4 className="modal-title">{this.state.modalTitle}</h4>
                <button type="button" className="close" onClick={this.modalBackgroundClicked} aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                {this.state.component ? <this.state.component inquiry={this.state.booking} handler={this.modalBackgroundClicked} invoiceHandler={this.invoiceHandler} createInvoiceHandler={this.createInvoiceHandler} inactivateHandler={this.inactivateHandler} notifyHandler={notify}/> : null}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={this.modalBackgroundClicked}>
                  Close
                </button>
            </div>
        </Modal>
        {this.state.servicesBooking && this.state.servicesComponent ?
          this.state.servicesComponent
        :
          <React.Fragment>
        <div className="main-content pt-0" ref={ (divElement) => this.divElement = divElement}>
          <div className="tab-content">
            <ToolkitProvider
              bootstrap4
              keyField="id"
              data={item_list}
              columns={columns}
              search={{searchFormatted:true}}
              srText="Search"
              expandRow={expandRow}
            >
              {
                props => (
                  <div className="mt-20">
                    <form role="form" id="accounts-form" className="form-type-combine">
                      <div className="form-groups-attached">
                        <div className="row">
                          <div className="form-group col-lg-3 col-md-4 col-sm-12">
                            <label className="d-block">Viewing</label>
                            <div className="btn-group">
                              <button type="button" className={filter === 'active' ? "btn btn-sm btn-primary" : "btn btn-sm btn-default"} onClick={()=>this.selectFilter('active')}>Active</button>
                              <button type="button" className={filter === 'new' ? "btn btn-sm btn-primary" : "btn btn-sm btn-default"} onClick={()=>this.selectFilter('new')}>New (4 days)</button>
                              <button type="button" className={filter === 'past' ? "btn btn-sm btn-primary" : "btn btn-sm btn-default"} onClick={()=>this.selectFilter('past')}>Past</button>
                              <button type="button" className={filter === 'inactive' ? "btn btn-sm btn-primary" : "btn btn-sm btn-default"} onClick={()=>this.selectFilter('inactive')}>Inactive</button>
                            </div>
                          </div>
                          <div className="form-group col-lg-3 col-md-4 col-sm-12">
                            <label>Search anything</label>
                            <SearchBar { ...props.searchProps } />
                          </div>
                        </div>
                      </div>
                    </form>
                    {loading ?
                      <h4 className="mt-20"><Spinner color="primary"/> Loading...</h4>
                    :
                    <BootstrapTable classes="table table-condensed table-striped m-b-20" pagination={paginationFactory(options)} {...props.baseProps} headerClasses="thead-light" selectRow={ selectRow }/>
                    }
                  </div>
                )
              }
            </ToolkitProvider>
          </div>
        </div>
        <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
        {this.state.quickviewBookingHashId ?
            <BookingQuickview2 hash_id={this.state.quickviewBookingHashId} closeHandler={this.closeQuickview} modalHandler={this.modalHandler} servicesHandler={this.servicesHandler} scheduleHandler={this.scheduleHandler} startTimeHandler={this.startTimeEdit} resetHandler={this.resetPassword} resendHandler={this.resendEmail} editHandler={this.editBooking}/>
          : <div>Loading</div>
        }
        </div>
        </React.Fragment>
        }
      </React.Fragment>);
  }
}

export default Bookings2;



// WEBPACK FOOTER //
// ./src/components/business/Bookings.2.js